module.exports = __webpack_public_path__ + "static/media/jsFramework.5b4a6449.svg";